export const mengisiLaporanKpiLeadershipSpec = [
  {
    form_field_type: 'CUSTOM_COMPONENT',
    label: 'Manager Username',
    name: 'managerUsername',
    type: 'text',
  },
  {
    form_field_type: 'CUSTOM_COMPONENT',
    label: 'Manager Name',
    name: 'manager',
    type: 'text',
  },
  {
    form_field_type: 'CUSTOM_COMPONENT',
    label: 'Job Position',
    name: 'jobPosition',
    type: 'text',
  },
]
